// extracted by mini-css-extract-plugin
export default {"overflow-container":"C9Wd1oRj0y","overflowContainer":"C9Wd1oRj0y"};